export const ToastConfig = {
  endClass: 'toast-message--end',
  types: ['error', 'info', 'confirm', 'cart', 'like', 'image', 'store_like'],
} as const;
